import { TRoadblockConfiguration } from "../roadblockTypesAndCodecs";
import { fact, formatEvidenceDate } from "../evidence/evidenceHelpers";

export const ChaseInstruction: TRoadblockConfiguration = {
    type: "chase_instruction",
    display_name: "Chase Instruction",
    only_create_if_resolved: [],
    requires_authoriser_signoff: false,
    blocks_exchange: false,
    create: {
        create_condition_description: "Cases that have been upgraded to a quote (not property-report-only) and where the quote has been sent to the client",
        predicate: (c) => !c.case.is_property_report && c.case.quote_sent_to_client !== null
    },
    checklist: [{
        type: "case_instructed",
        is_resolved_by_short_description: "Case instructed",
        create: {
            create_condition_description: "All cases",
            predicate: () => true
        },
        resolve: {
            is_resolved_by_long_description: `Instructing the case.`,
            predicate: (c) =>
                c.case.is_instructed !== null,
            evidence: (c) => [
                fact(
                    "Case instructed",
                    c.case.is_instructed ? `Instructed ${formatEvidenceDate(c.case.is_instructed)}` : "Not instructed",
                    c.case.is_instructed !== null,
                ),
            ],
        }
    }]
};
